import React from 'react'
import { HiInformationCircle } from 'react-icons/hi'
import { Popup } from 'semantic-ui-react'
import styles from './styles.module.less'

export interface HelperTextLabelProps {
  label: string
  helperText?: string
}

const HelperTextLabel = ({ label, helperText }: HelperTextLabelProps) => {
  return (
    <label className={`label ${styles.helperTextLabel}`}>
      <span className="label-contents">{label}</span>
      {helperText && (
        <span className={styles.helperTextSymbol}>
          <Popup content={helperText} trigger={<HiInformationCircle />} offset={[-12, 0]} />
        </span>
      )}
    </label>
  )
}

export default HelperTextLabel
